module.exports = __webpack_public_path__ + "img/25-Immunity.0411af76.png";